import { request } from '@/common/services/request';

const getPayloadData = (payload) => payload?.data || payload || {};

const toProTableResult = (result) => ({
  data: result.data,
  success: true,
  total: result.meta?.total || 0,
});

export async function queryAvailableAgents(params) {
  const result = await request('/api/agents/available', {
    method: 'GET',
    params,
  });
  return result.data || [];
}

const getAgentTitle = (agents, agentId) =>
  agents.find((agent) => agent.agentId === agentId)?.title || agentId;

const getRunAgentInput = (run) => (Array.isArray(run.input) ? run.input[0] : run.input);

const getRunAgentId = (run) => run.agentId || getRunAgentInput(run)?.agentId;

const getRunSummary = (run) => run.summary || run.output?.summary;

export async function queryAgents(params) {
  const agents = await queryAvailableAgents(params);
  const keyword = typeof params?.title === 'string' ? params.title.trim() : '';
  const data = keyword ? agents.filter((agent) => agent.title?.includes(keyword)) : agents;
  return {
    data,
    success: true,
    total: data.length,
  };
}

export async function queryAgentSchedules(params) {
  const [agents, result] = await Promise.all([
    queryAvailableAgents({ organizationId: params?.organizationId }),
    request('/api/agents/schedules', {
      method: 'GET',
      params,
    }),
  ]);
  return toProTableResult({
    ...result,
    data: (result.data || []).map((schedule) => ({
      ...schedule,
      agentTitle: getAgentTitle(agents, schedule.agentId),
    })),
  });
}

export async function createAgentSchedule(payload) {
  const data = getPayloadData(payload);
  return request('/api/agents/schedules', {
    method: 'POST',
    params: {
      organizationId: data.organizationId,
    },
    data: {
      agentId: data.agentId,
      cron: data.cron,
      status: data.status,
    },
  });
}

export async function updateAgentSchedule(payload) {
  const data = getPayloadData(payload);
  return request('/api/agents/schedules', {
    method: 'PATCH',
    params: {
      organizationId: data.organizationId,
      scheduleId: data.id,
    },
    data: {
      cron: data.cron,
      status: data.status,
    },
  });
}

export async function removeAgentSchedule(payload) {
  const data = getPayloadData(payload);
  return request('/api/agents/schedules', {
    method: 'DELETE',
    params: {
      organizationId: data.organizationId,
      scheduleId: data.id,
    },
  });
}

export async function queryAgentRuns(params) {
  const [agents, result] = await Promise.all([
    queryAvailableAgents({ organizationId: params?.organizationId }),
    request('/api/agents/runs', {
      method: 'GET',
      params,
    }),
  ]);
  return toProTableResult({
    ...result,
    data: (result.data || []).map((run) => ({
      ...run,
      agentId: getRunAgentId(run),
      agentTitle: getAgentTitle(agents, getRunAgentId(run)),
      summary: getRunSummary(run),
    })),
  });
}

export async function triggerAgentRun(payload) {
  const data = getPayloadData(payload);
  return request('/api/agents/runs', {
    method: 'POST',
    params: {
      organizationId: data.organizationId,
    },
    data: {
      agentId: data.agentId,
      payload: data.payload,
      requestId: data.requestId,
    },
  });
}
